export default __webpack_public_path__ + "static/media/JohnOConnor.660ddee1.png";